
import { useState, useEffect} from "react";
import { useHistory } from "react-router-dom";
import LocalStorage from "../LocalStorage";
import useWebsiteModules from "./useAccessModules";
import useSocialLinks from "./useSocialMediaLinks";
import useMemeberInfo from "./useMemeberInfoHook";
import useFeaturedListings from "./useCommonHook";
import {

  thumborImageUrl,
  getDomainValue,
} from "../Utility";

const SERVICES_ADDITIONAL_PAGE_DATA = [
  { slug_url: "services", is_show: true },
  { slug_url: "terms-and-conditions", is_show: true },
];

const useNavbarInfo = () => {
  const {username,memberProfile,isLoggedIn} = useMemeberInfo();
  const websiteModules = useWebsiteModules();
  const articles = useFeaturedListings('articles');
 const {
    flight = false,
    hotel = false,
    packages_api = false,
    news = false,
    pay_safely = true,
    packages=false,
    remit_allowed = true,
    video_tours = true,
  } = websiteModules;
  const showPackages = packages || packages_api;
  const {
    logo_url = null,
    emails = [],
    phone_numbers = [],
  } = memberProfile;
  const socialMedia = useSocialLinks();
  const domainName = getDomainValue();
  const history = useHistory();
  const [knowUsItem, setKnowUsItem] = useState([
    { name: "About Us", link: `/${username ? `${username}/` : ""}about`, reloadLink: true },
    { name: "Contact Us", link: `/${username ? `${username}/` : ""}contact` },
  ]);

  const loginItem = [
    {
      id: "bookings",
      name: "My Bookings",
      link: `/${username ? `${username}/` : ""}en/my_bookings`,
    },
    {
      id: "logout",
      name: "Logout",
      isBtn: true,
    },
  ];
  const loginMenu = {
    id: "login",
    name: "Login",
    isBtn: true,
    isDropdown: true,
    isShow: true,
    link: "",
    dropDownItem: loginItem,
  };
  const [contentArr, setContentArr] = useState([]);
  const addToKnowUsItem = (pages = []) => {
    const newItems = [...knowUsItem];
    pages.forEach((item) => {
      if (item.slug_url && item.is_show) {
        const name = item.slug_url.replace(/_|-/g, " ");
        const capitalized = name.charAt(0).toUpperCase() + name.slice(1);
        newItems.push({
          name: capitalized,
          link: {
            pathname: `/${username ? `${username}/` : ""}pages/${item.slug_url}`,
            state: item,
          },
        });
      }
    });
    setKnowUsItem(newItems);
  };
 useEffect(() => {
 const arr = [
  {
    id: "flights",
    name: "Flights",
    isShow: flight,
    isDropdown: false,
    link: `/${username ? `${username}/` : ""}flights`,
  },
  {
    id: "hotels",
    name: "Hotels",
    isShow: hotel,
    isDropdown: false,
    link: `/${username ? `${username}/` : ""}hotelsearch/`,
  },
  {
    id: "packages_api",
    name: "Packages",
    isShow: packages_api && showPackages,
    isDropdown: false,
    link: `/${username ? `${username}/` : ""}package/`,
  },
  {
    id: "packages_other",
    name: "Packages",
    isShow: !packages_api && showPackages,
    isDropdown: false,
    link: `/${username ? `${username}/` : ""}packages/`,
  },
  {
    id: "remit",
    name: "Remit",
    isShow: remit_allowed,
    isDropdown: false,
    link: `/${username ? `${username}/` : ""}remittance`,
  },
  {
    id: "news",
    name: "News",
    isShow: news,
    isDropdown: false,
    link: `/${username ? `${username}/` : ""}news`,
  },
  {
    id: "video_tours",
    name: "Video Tours",
    isShow: video_tours,
    isDropdown: false,
    link: `/${username ? `${username}/` : ""}destination-guides/`,
  },
  {
    id: "pay_safely",
    name: "Pay Safely",
    isShow: pay_safely,
    isDropdown: false,
    link: `/${username ? `${username}/` : ""}pay`,
  },
  {
    id: "knowMore",
    name: "Know More",
    isDropdown: true,
    isShow: true,
    dropDownItem: knowUsItem.map((item, index) => ({
      id: `knowUsItem-${index}`,
      name: item.name,
      link: item.link,      
      reloadLink: item.reloadLink || false,
    })),
  },
  loginMenu,
].filter((item) => item.isShow);


  setContentArr(arr);
}, [websiteModules, knowUsItem]);

  useEffect(() => {
    if (domainName) addToKnowUsItem([...articles, ...SERVICES_ADDITIONAL_PAGE_DATA]);
  }, [domainName]);
  const handleMenuItemClick = (item) => {
    if (isLoggedIn && item.id === "logout") {
      handleLogout();
      return;
    }
    if (item.reloadLink) window.location = item.link;
    else history.push(item.link);
  };
  const handleLogout = () => {
    LocalStorage.deleteUser();
    history.push(`/${username ? `${username}/` : ""}`);
    window.location.reload();
  };
  const getLogoUrl = (url = "") => {
    if (!url) return null;
    const replaceStr = "https://s3.ap-south-1.amazonaws.com/com.travclan.b2b2c/";
    if (url.includes("cms/media")) {
      url = decodeURIComponent(url);
      url = url.slice(replaceStr.length + "https:".length);
      url = `https:/${url}`;
    }
    return thumborImageUrl(url, 0, 100);
  };
  return {
    memberProfile,
    logo_url,
    contentArr,
    socialMedia,    
    emails,         
    phone_numbers, 
    handleMenuItemClick,
    handleLogout,
    getLogoUrl,
  };
};

export default useNavbarInfo;
